// Which of legacy's inspection-record tabs a record shows, in legacy's order
// (H98). The GATES are the backend's (GET /v6/inspection/record-tabs/{id},
// app/inspections/record_tabs.py): creep_type 6 hides BOM + Linked To; no
// global_template_db hides Task/Check List. This hook only asks, so the two
// record screens that render an inspection — src/inspections/InspectionDetail
// (nav row 267, what Peak and g2 open) and src/inspections-tr/InspectionsTREdit
// (the Aircraft Templates shell) — cannot drift apart on which tabs exist.
//
// Before the answer arrives (and on the create route, where there is no record
// to gate) only General and Aircraft List render — the two tabs every
// inspection has. If the read FAILS the same two render and the snackbar says
// so; the other tabs are not guessed into existence.
import React, { useEffect, useState } from "react";
import { useSnackbar } from "notistack";

import { getInspectionRecordTabs } from "./inspections_tr";
import type { InspectionRecordTab, InspectionRecordTabKey } from "./types";
import {
  InspectionAtaHistoryTab,
  InspectionBomTab,
  InspectionConfigListTab,
  InspectionLinkedToTab,
  InspectionSpecialTasksTab,
  InspectionTaskListTab,
} from "./tabs/InspectionsTRRecordTabs";

export const ALWAYS_TABS: InspectionRecordTab[] = [
  { key: "general", label: "General", shown: true, hidden_reason: null },
  { key: "aircraft_list", label: "Aircraft List", shown: true, hidden_reason: null },
];

/** The six list tabs both hosts render identically. General and Aircraft List stay the host's own. */
export const RECORD_LIST_TAB_BODY: Partial<
  Record<InspectionRecordTabKey, (inspectionId: number) => React.ReactNode>
> = {
  config_list: (id) => <InspectionConfigListTab inspectionId={id} />,
  bom: (id) => <InspectionBomTab inspectionId={id} />,
  linked_to: (id) => <InspectionLinkedToTab inspectionId={id} />,
  ata_history: (id) => <InspectionAtaHistoryTab inspectionId={id} />,
  task_list: (id) => <InspectionTaskListTab inspectionId={id} />,
  special_tasks: (id) => <InspectionSpecialTasksTab inspectionId={id} />,
};

export function useInspectionRecordTabs(inspectionId?: number): InspectionRecordTab[] {
  const { enqueueSnackbar } = useSnackbar();
  const [tabs, setTabs] = useState<InspectionRecordTab[]>(ALWAYS_TABS);

  useEffect(() => {
    setTabs(ALWAYS_TABS);
    if (!inspectionId) return;
    let cancelled = false;
    getInspectionRecordTabs(inspectionId)
      .then((resp) => {
        if (!cancelled && resp?.tabs?.length) setTabs(resp.tabs.filter((t) => t.shown));
      })
      .catch(() => {
        if (!cancelled) enqueueSnackbar("Error fetching this inspection's tabs", { variant: "error" });
      });
    return () => {
      cancelled = true;
    };
  }, [inspectionId, enqueueSnackbar]);

  return tabs;
}
